/**
 * Sincroniza classe no #header-group quando o drawer mobile abre/fecha.
 * Evita depender só de :has() (Safari antigo) e permite esconder ícones com display:none.
 */
(function () {
  const DETAILS_ID = 'Details-menu-drawer-container';

  const sync = () => {
    const details = document.getElementById(DETAILS_ID);
    const root = document.getElementById('header-group');
    if (!details || !root) return;

    const open =
      details.hasAttribute('open') ||
      details.classList.contains('menu-open') ||
      details.classList.contains('menu-opening');

    root.classList.toggle('andrade-menu-drawer-open', open);
  };

  const observe = () => {
    const details = document.getElementById(DETAILS_ID);
    if (!details || details.dataset.andradeDrawerSync === '1') return;

    details.dataset.andradeDrawerSync = '1';
    sync();

    new MutationObserver(sync).observe(details, {
      attributes: true,
      attributeFilter: ['open', 'class'],
    });

    details.addEventListener('toggle', sync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', observe);

  function bindLogoHome() {
    var root = document.getElementById('header-group');
    if (!root || root.dataset.andradeLogoHome === '1') return;
    root.dataset.andradeLogoHome = '1';

    var touchStart = null;

    root.addEventListener(
      'touchstart',
      function (event) {
        var link = event.target.closest && event.target.closest('a.andrade-logo, a.header-logo');
        var touch = event.changedTouches && event.changedTouches[0];
        touchStart = link && touch ? { x: touch.clientX, y: touch.clientY } : null;
      },
      { capture: true, passive: true }
    );

    var goHome = function (event) {
      var link = event.target.closest && event.target.closest('a.andrade-logo, a.header-logo');
      if (!link || !root.contains(link)) return;
      if (event.type === 'touchend') {
        var touch = event.changedTouches && event.changedTouches[0];
        if (!touchStart || !touch) return;
        if (Math.abs(touch.clientX - touchStart.x) > 12 || Math.abs(touch.clientY - touchStart.y) > 12) return;
      }
      var dest;
      try {
        dest = new URL(link.href, window.location.href);
      } catch (err) {
        return;
      }
      if (dest.origin !== window.location.origin) return;
      var here = window.location.pathname === '' ? '/' : window.location.pathname;
      if (dest.pathname === here && dest.search === window.location.search) return;
      event.preventDefault();
      window.location.href = dest.href;
    };

    root.addEventListener('click', goHome, true);
    root.addEventListener('touchend', goHome, { capture: true, passive: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLogoHome);
  } else {
    bindLogoHome();
  }

  document.addEventListener('shopify:section:load', bindLogoHome);
})();
